module.exports = __webpack_public_path__ + "static/BannerAcademy-0244625fcb8c106bef3aebe0a0f58cb6.png";